import { AppInfoViewComponent } from '@addins/app-info/src/views/app-info-view/app-info-view.component';
import { Injectable } from '@angular/core';
import { MenuEntry } from '@services/menu/entry.schema';
import { SideMenuService } from '@services/menu/side-menu.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';

@AddinExecute({
  name: 'AppInfo',
  description: 'Add a menu entry to display About menu'
})
@Injectable()
export class AppInfoSetupService extends Execute {
  private menuEntry: MenuEntry = null;

  constructor(private sideMenuService: SideMenuService) {
    super();
  }

  execute() {
    this.menuEntry = new MenuEntry('AppInfo', 'information-circle', AppInfoViewComponent, -2);
    this.sideMenuService.addMenuEntry(this.menuEntry);
  }

  destroy() {
    if (this.menuEntry !== null) {
      this.sideMenuService.removeMenuEntry(this.menuEntry);
      this.menuEntry = null;
    }
  }
}
